/* import __COLOCATED_TEMPLATE__ from './categories-and-latest-topics.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./categories-and-latest-topics.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  classNames: ["categories-and-latest"]
}));